import type { TCalculateTariffPaymentProps } from './models';

import {
    calculatePercentFromSum,
    overpaymentsFormulas,
    paymentsFormulas,
    transformValue,
} from './index';

export const calculateTariffPayment = ({
    countingType,
    parameters,
    percentValue,
}: TCalculateTariffPaymentProps) => {
    const { amount, term } = parameters;

    if (!amount || !term || !countingType) {
        return { monthPayment: null, overPayment: null };
    }

    const finalPercent = calculatePercentFromSum(transformValue(percentValue), parameters);
    const calculatedPayment = paymentsFormulas[countingType](amount, finalPercent, Number(term));
    const monthPayment = calculatedPayment.toFixed().toString();

    if (countingType !== 'annuity' && countingType !== 'dif') {
        return {
            monthPayment,
            overPayment: null,
        };
    }

    const overPayment = overpaymentsFormulas[countingType](
        amount,
        finalPercent,
        Number(term),
        calculatedPayment
    )
        .toFixed()
        .toString();

    return {
        monthPayment,
        overPayment,
    };
};
